<template>
  <div
    class="video video1 video--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical background-cover"
    :class="`bg-${backgroundColor} `"
    :id="`Video1-${pageUid}`">
    <div class="container margin-auto">
      <div
        v-if="isNonEmptyString(title)"
        class="title-container width-expand flex flex-center margin-xl-bottom l:margin-2xl-bottom">
        <h2
          :class="`c-${titleColor}`"
          class="video-title text-center bold text-3xl l:text-max margin-remove">
          {{ title }}
        </h2>
      </div>
      <div class="video-wrapper relative">
        <div
          style="max-width: 840px; aspect-ratio: 16 / 9"
          class="video-ratio-container border-radius-s margin-auto-inline relative z-level-2 border-radius">
          <div
            v-if="videoCoverImage.show && !showVideoIframe"
            @click="
              track('video1|coverImage|click', { value: title }).then(showVideo)
            "
            class="cursor-pointer video-cover relative bg-danger width-expand relative z-level-2 border-radius background-cover relative"
            :style="`background-image: url('${videoCoverImage.finalSrc}')`"
            style="height: 100%">
            <div class="absolute-center font-max">
              <icon-halo
                :size="3"
                style="padding-left: 4px"
                icon="mc-play"
                :halo-theme="titleColor"
                theme="bg"></icon-halo>
            </div>
          </div>
          <iframe
            v-if="showVideoIframe && ! $s.isCrawler"
            class="relative z-level-2 border-radius"
            style="border: none"
            loading="lazy"
            width="100%"
            height="100%"
            :src="`https://www.youtube.com/embed/${videoId}?autoplay=${
              videoAutoPlay ? 'true' : 'false'
            }&rel=0`"
            title="YouTube video player"
            allow="accelerometer; clipboard-write; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      videoId: "",
      videoCoverImage: {},
      sectionBackgroundImage: {},
      backgroundColor: "",
      titleColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    // if have cover - default off
    let initialShowVideoIframeState = !this.videoCoverImage.show;
    return {
      // if we show initially - no autoplay
      videoAutoPlay: !initialShowVideoIframeState,
      showVideoIframe: initialShowVideoIframeState,
    };
  },
  methods: {
    showVideo() {
      this.showVideoIframe = true;
    },
    blurHandler() {
      setTimeout(() => {
        if (document.activeElement.tagName === "IFRAME") {
          try {
            this.track("video1|video|click", {
              value: this.videoId,
            }).then(() => {});
          } catch (e) {}
        }
      });
    },
  },
  computed: {
    shadowImage() {
      return this.requireAsset(`images/lp/sections/video1/shadow.png`);
    },
    shadowImageBackgroundImageProperty() {
      return `url('${this.shadowImage}')`;
    },
    hasCover() {
      return this.videoCoverImage.show;
    },
    hasBackgroundImage() {
      return this.sectionBackgroundImage.show;
    },
    backgroundImage() {
      return this.sectionBackgroundImage.finalSrc;
    },
    backgroundImageBackgroundImageProperty() {
      if (this.hasBackgroundImage) {
        return `url('${this.backgroundImage}')`;
      } else {
        return `none`;
      }
    },
  },
  mounted() {
    try {
      window.focus();
      window.addEventListener("blur", this.blurHandler, { once: true });
    } catch (e) {}
  },
  beforeUnmount() {
    try {
      window.removeEventListener("blur", this.blurHandler);
    } catch (e) {}
  },
};
</script>

<style scoped lang="scss">
.video1 {
  background-size: cover;
  background-repeat: no-repeat;
  background-image: v-bind(backgroundImageBackgroundImageProperty);

  .video-wrapper {
    &::after {
      content: " ";
      position: absolute;

      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center 120%;
      background-image: v-bind(shadowImageBackgroundImageProperty);
      height: 90px;
      z-index: var(--z-1);
      top: calc(100% - 20px);
      @media (max-width: 1024px) {
        top: calc(100% - 10px);
        height: 40px;
      }
    }
  }
}
</style>
